// Reserved placeholder row id. Several tables carry an internal placeholder row
// under this id (the placeholder organizer, location, merchant/organizergroup,
// event, etc. — see kudukey-kb/merchant-scoping.md). These are system defaults,
// not real records, so they should not appear in the admin lists or the merchant
// filter dropdown.
export const PLACEHOLDER_ID = 100001;

// Drop the placeholder row (id === 100001) from a list of rows.
export const withoutPlaceholder = (rows) => (rows || []).filter((row) => Number(row?.id) !== PLACEHOLDER_ID);
